<ag-grid-angular [rowData]="transactions()" [columnDefs]="columnDefs" [gridOptions]="tableDef" [loading]="isLoading()"></ag-grid-angular>
